// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the MIT License.

export const version = '4.10.0';

export const returnBindingKey = '$return';
